/**
 * Helpers condivisi per widget delle Relazioni Mensili.
 */
export const MONTHS_FULL = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export function fmtNumber(v) {
  if (v == null || v === "") return "—";
  const n = parseFloat(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("it-IT", { maximumFractionDigits: 2 });
}

// Card KPI per la sezione tabella_annuo (YTD, media)
export function kpiCard(label, value, target, higherIsBetter = true, unit = "", decimals = 0, key = null) {
  const hasVal = value != null && !Number.isNaN(value);
  const hasTgt = target != null && !Number.isNaN(target);
  let met = null;
  if (hasVal && hasTgt) met = higherIsBetter ? value >= target : value <= target;
  return (
    <div key={key || label} className="rounded-xl border border-border/60 p-3 space-y-1 bg-background/40">
      <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground">{label}</div>
      <div className={`text-xl font-display tabular-nums ${met === true ? "text-emerald-500" : met === false ? "text-red-500" : ""}`}>
        {hasVal ? value.toLocaleString("it-IT", { maximumFractionDigits: decimals }) : "—"}{unit}
      </div>
      {hasTgt && (
        <div className="text-[10px] text-muted-foreground tabular-nums">
          Target: {target.toLocaleString("it-IT", { maximumFractionDigits: decimals })}{unit}
          {hasVal && (
            <span className={`ml-1.5 ${met ? "text-emerald-500" : "text-red-500"}`}>
              {met ? "✓" : "✗"} {((value / target) * 100).toFixed(0)}%
            </span>
          )}
        </div>
      )}
    </div>
  );
}
